export default __webpack_public_path__ + "static/media/Banner6.ee0b94f6.jpg";